const Style = {
    stack: 'space-y-6',
    header: 'flex flex-wrap items-start justify-between gap-3',
    title: 'text-xl font-semibold text-text-primary',
    description: 'mt-1 text-sm text-text-secondary',
    grid: 'grid gap-4 sm:grid-cols-2 xl:grid-cols-3',
    card: 'flex flex-col',
    cardButton: 'w-full flex-1 text-left',
    cardTop: 'mb-3 flex items-start justify-between gap-2',
    mark: 'flex h-10 w-10 items-center justify-center overflow-hidden rounded-md bg-muted text-text-secondary',
    logo: 'h-full w-full object-cover',
    cardTitle: 'truncate text-base font-semibold text-text-primary',
    cardMeta: 'mt-1 text-xs text-text-muted',
    cardActions: 'mt-4 flex items-center gap-2 border-t border-border pt-3',
};

export default Style;
